import { ProviderType, RedirectOutputType } from './providerTypes'
import { constructDIDProviderUrl } from '@/utils/didHelpers'

export const bankId: ProviderType = {
  id: 'bankId',
  displayName: 'BankId',
  showLogo: false,
  showSubmit: false,
  redirectOutput: (): RedirectOutputType => {
    return {
      url: constructDIDProviderUrl(
        {
          provider: 'bankid-se',
          display: 'popup',
          country: 'SE',
          theme: 'piq-1'
        }
      ),
      id: 'bankId',
      container: 'iframe',
      autoShow: {
        default: true,
        mobile: false
      },
      containerHeight: 320
    }
  }
}
